document.addEventListener('DOMContentLoaded', () => {
  const pills = document.querySelectorAll('.cfaq-pill');
  const blocks = document.querySelectorAll('.cfaq-block');

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const blockIndex = pill.dataset.blockIndex;

      // Remove active class from all pills and blocks
      pills.forEach((p) => p.classList.remove('cfaq-pill--active'));
      blocks.forEach((b) => b.classList.remove('cfaq-block--active'));

      // Add active class to clicked pill
      pill.classList.add('cfaq-pill--active');

      // Add active class to matching block
      const targetBlock = document.querySelector(`.cfaq-block[data-block-index="${blockIndex}"]`);
      if (targetBlock) {
        targetBlock.classList.add('cfaq-block--active');
      }
    });
  });
});